<template>
    <div class="library">
        <horizontal-slider
            class="hidden-sm-and-up"
            v-if="typeList.length !== 0"
            :list="typeList"
            :index="index"
            @handleClick="handleChangeType"
        ></horizontal-slider>
        <!-- 头部 -->
        <div class="head_picture">
            <img src="../assets/images/banner_4.png" class="hidden-xs-only" />
            <img src="../assets/images/banner_44.png" class="hidden-sm-and-up" />
        </div>
        <!-- 主体 -->
        <div class="section main">
            <div class="main_left hidden-xs-only">
                <div class="main_left_title">
                    <img src="../assets/images/title_library.png" />
                </div>
                <div class="main_left_content">
                    <p v-for="(item, i) in typeList" :key="i" :class="[ index == item.id ? 'list_active' : '' ]" @click="handleChangeType(item.id)">{{ item.title }}</p>
                </div>
            </div>
            <div class="main_right" v-loading="loading">
                <div class="crumb_navigation">
                    <span>当前位置：</span>
                    <span>联盟智库</span><i class="el-icon-arrow-right"></i>
                    <span>{{ crumb_title }}</span>
                </div>
                <div class="news_content">
                    <a href="javascript:void(0)" v-for="(item, i) in newsList" :key="i" @click="linkToDetails(item.id)">
                        <span>{{ item.title }}</span>
                        <span>{{ item.releaseTime | dateFilter }}</span>
                    </a>
                    <p v-if="newsList.length === 0">暂无数据</p>
                </div>
                <!-- 分页 -->
                <el-pagination
                    :current-page="query.current"
                    :page-size="query.pageSize"
                    :page-sizes="[10, 20, 30, 40]"
                    :total="total"
                    :pager-count="5"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    layout="total, sizes, prev, pager, next, jumper"
                >
                </el-pagination>
            </div>
        </div>
        <!--  -->
    </div>
</template>

<script>
import HorizontalSlider from '../components/HorizontalSlider.vue'
import { newsType, newsList } from '../untils/common-api.js'
export default {
    data() {
        return {
            loading: false,
            // 
            index: null,
            typeList: [],
            // 
            total: null,
            query: {
                current: 1,
                pageSize: 10,
                newsType: null
            },
            newsList: []
        }
    },
    methods: {
        // 获取新闻类别、默认类别
        async getNewsType() {
            let res = await newsType()
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            res.data.records.forEach(item => {
                if (item.themeTitle === '联盟智库') {
                    this.typeList.push({
                        id: item.id,
                        title: item.typeName
                    })
                }
            })
            if (this.$route.query.type) {
                this.index = this.$route.query.type
                this.query.newsType = this.$route.query.type
            } else {
                this.index = this.typeList[0].id
                this.query.newsType = this.typeList[0].id
            }
            this.getNewsList()
        },
        // 获取新闻列表
        async getNewsList() {
            this.loading = true // loading start
            let res = await newsList(this.query)
            this.loading = false // loading end
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            this.total = res.data.total
            this.newsList = res.data.records
        },
        handleCurrentChange(data) {
            this.query.current = data
            this.getNewsList()
        },
        handleSizeChange(data) {
            this.query.pageSize = data
            this.getNewsList()
        },
        // 更改类型
        handleChangeType(id) {
            window.location.href = '/#/library?type=' + id
            this.index = id
            this.query.newsType = id
            this.query.current = 1
            this.getNewsList()
        },
        // 跳转详情
        linkToDetails(id) {
            this.$router.push({name: 'details', params: { name: 'library', type: this.index, id: id } })
        }
    },
    components: {
        HorizontalSlider
    },
    // 获取crumb_title
    computed: {
        'crumb_title': function() {
            let crumbTitle = ''
            this.typeList.forEach(item => {
                if (this.index == item.id) {
                    crumbTitle = item.title
                }
            })
            return crumbTitle
        }
    },
    created() {
        this.getNewsType()
    }
}
</script>

<style lang="less">
.library {
    .main {
        color: #666;
        overflow: auto;
        .main_left {
            width: 20%;
            float: left;
            background: #fff;
            .main_left_title {
                margin-bottom: 10px;
                img {
                    width: 100%;
                }
            }
            .main_left_content {
                p {
                    font-size: 15px;
                    line-height: 45px;
                    text-align: center;
                    border-bottom: 1px solid #dcdcdc;
                    transition: 0.3s ease all;
                    cursor: pointer;
                    &:hover {
                        color: #037EDB;
                        background: #dcdcdc;
                    }
                }
            }
        }
        .main_right {
            width: calc(80% - 40px);
            float: right;
            background: #fff;
            .news_content {
                margin-bottom: 25px;
                a {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    color: #555!important;
                    font-size: 15px;
                    line-height: 45px;
                    border-bottom: 1px dashed #e5e5e5;
                    padding: 0 5px;
                    &:hover {
                        background: #ececec;
                    }
                    span:first-child {
                        display: inline-block;
                        max-width: 78%;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        &::before {
                            content: '';
                            display: inline-block;
                            width: 5px;
                            height: 5px;
                            background: #4db62b;
                            margin-right: 10px;
                            transform: translateY(-2px);
                        }
                    }
                }
                p {
                    font-size: 15px;
                    line-height: 45px;
                    text-align: center;
                }
            }
            .el-pagination {
                text-align: center;
            }
        }
    }
    .list_active {
        color: #037EDB;
        background: #dcdcdc;
    }
}
@media (max-width: 768px) {
    .library {
        .main {
            .main_right {
                width: 100%;
                .crumb_navigation {
                    margin-bottom: 0.25rem;
                }
                .news_content {
                    margin-bottom: 0.3rem;
                    a {
                        font-size: 0.28rem;
                        line-height: 0.85rem;
                        padding: 0;
                        span:first-child {
                            max-width: 72%!important;
                            &::before {
                                width: 0.1rem;
                                height: 0.1rem;
                                margin-right: 0.2rem;
                                transform: translateY(-0.05rem);
                            }
                        }
                    }
                }
                .el-pagination .el-pagination__sizes, .el-pagination .el-pagination__jump {
                    display: none;
                }
                .el-pagination button, .el-pagination li {
                    font-size: 0.28rem;
                    padding: 0;
                    min-width: 0.5rem;
                }
                .el-pagination button {
                    margin: 0 0.1rem;
                }
                .el-pagination .btn-next .el-icon {
                    font-size: 0.28rem;
                }
            }
        }
    }
}
</style>